import { IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { Location } from "react-router-dom";

/**
 * Parameters required to build ZedXMainApp breadcrumb
 */
export interface ZedXMainAppBreadcrumbParams {
    customerTitle: string;
    location: Location;
    history: any; // You can replace with `NavigateFunction` if you want stricter typing
}

export const buildZedXMainAppBreadcrumb = (): IBreadcrumbItem[] => {
    const items: IBreadcrumbItem[] = [
        {
            text: "ZedX Apps",
            key: "root",
            href: "/", // clickable root
        },
        {
            text: "Select Account",
            key: "select-account",
            isCurrentItem: true, // bold and not clickable
        }
    ];

    return items;
};

export const buildCreateAccountBreadcrumb = (): IBreadcrumbItem[] => {

    const items: IBreadcrumbItem[] = [
        {
            text: "ZedX Apps",
            key: "root",
            href: "/"
        },
        {
            text: "Create Account",
            key: "create-account",
            isCurrentItem: true
        }
    ];

    return items;
};